import { Component } from '@angular/core';

@Component({
     
    selector: 'authentification',
    templateUrl: 'authentification.component.html',
    styleUrls: ['authentification.component.scss']
})
export class AuthentificationComponent {

}
